import { Navigate, RouteObject } from "react-router-dom";

import DocumentsPage from "components/Documents";
import PageNotFound from "components/PageNotFound";
import SingleCustomerSelectionCheck from "components/SingleCustomerSelectionCheck";
import Unauthorized from "components/Unauthorized/Unauthorized";
import UserManagementPage from "components/UserManagement/UserManagementPage";
import {
  contractsPath,
  documentsPath,
  requestContractPath,
  userManagementPath,
} from "constants/paths";
import RequestParamsProvider from "contexts/RequestParamsProvider";
import { SORT_DIRECTION } from "hooks/useSort";
import { AppLayout, NavigationLayout } from "layouts";
import RequestContractPage from "routes/RequestContractPage";
import ContractsPage from "routes/contracts/ContractsPage";

const appRoutes: RouteObject[] = [
  {
    element: <AppLayout />,
    children: [
      {
        path: "*",
        element: <NavigationLayout />,
        children: [
          { path: contractsPath, element: <ContractsPage /> },
          {
            path: requestContractPath,
            element: <RequestContractPage />,
          },
          { path: `${documentsPath}/*`, element: <DocumentsPage /> },
          {
            path: userManagementPath,
            element: (
              <RequestParamsProvider
                initialSort={{
                  key: "LastName",
                  direction: SORT_DIRECTION.ASC,
                }}
              >
                <SingleCustomerSelectionCheck actionDescription="access User Management">
                  <UserManagementPage />
                </SingleCustomerSelectionCheck>
              </RequestParamsProvider>
            ),
            errorElement: <Unauthorized />,
          },
          {
            path: "*",
            element: <PageNotFound />,
          },
        ],
      },
    ],
  },
  { path: "*", element: <Navigate to={contractsPath} replace /> },
  { index: true, element: <Navigate to={contractsPath} replace /> },
];

export default appRoutes;
